import React, { useState, useEffect } from "react";
import { Typography, Table, Collapse, Card ,Space} from "antd";
import { validationErrors } from "../../../../../utils/Helpers";
import Pageloader from "../../../../../components/loader";
import moment from "moment";
import * as orderManagementActions from "../../../../../redux/actions/orderManagement.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { Text } = Typography;
const { Panel } = Collapse;

const OrderAssignStory = (props) => {
  const pagename = "Assign Story";
  const [postData, setPostData] = useState(null);
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   postLists();
  // }, [props.pageorderid]);

  const postLists = async () => {
    try {
      setLoading(true);
      const {data} = await props.orderManagementActions.assignStoryAction(props.pageorderid);
      setPostData(data.data);
    } catch (e) {
      validationErrors(e);
    } finally {
      setLoading(false);
    }
  };

  const postColumns = [
    {
      title: "Date Time",
      render: (created_at) => {return created_at?moment(created_at).format("DD MMMM, yyyy, h:mm:ss A"): "";},
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "Log",
      render: (log) => {return log?<Text>{log.title}</Text> : "";},
      dataIndex: "log",
      key: "log",
    },
    {
      title: "Agent",
      key: "agent",
      render: (_, record) => {
        const name = record?.agent?.name;
        const email = record?.agent?.email;
        if (!name && !email) return "-";
        return (
          <span>
            {name || "-"}{email ? ` (${email})` : ""}
          </span>
        );
      },
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      render: (value) => value ? <Text>{value}</Text> : "-",
    },
    {
      title: "Comment",
      dataIndex: "comment",
      key: "comment",
      render: (value) => value ? <Text>{value}</Text> : "-",
    },
  ];

  return (
    <Card title={pagename} bordered>
      <Collapse onChange={postData===null?postLists:()=>{}}>
        <Panel header={pagename}>
          {loading ? (
            <Pageloader />
          ) : (
            <Space direction="vertical" style={{width: "100%"}}>
              <Collapse>
                {postData &&
                  postData.pickup
                  .map((item, i) => {
                    return (
                      <Panel header={item.rider.fullName} key={i}>
                        <Table dataSource={item.status} columns={postColumns} pagination={false}/>
                      </Panel>
                    );
                  })}
              </Collapse>
            </Space>
          )}
        </Panel>
      </Collapse>
    </Card>
  );
};

const mapStateToProps = (state) => {
  return {
    taskDetailData: state.OrderManagementReducer.taskDetailData,
    emailUser: state.authReducer.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    orderManagementActions: bindActionCreators(orderManagementActions, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderAssignStory);
